<h2 style="margin-bottom: 1.5px; text-align: center;">
    Are you sure you want to
</h2>
<h2 style="margin-top: 0; text-align: center;">
    make this the current version?
</h2>
<div style="text-align: center;">
    <span style="color: #757575;">Your FlyMSG will be changed.</span>
</div>
<div style="display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 45px; margin-bottom: 12px;">
    <!-- V2-11: `outline`, not `secondary` — secondary paints a near-black
         label/border master never had; every other dismiss button in the app
         uses the orange outline treatment (see confirm-dialog). -->
    <button class="hide-on-mobile" id="cancel" type="button" vng-button variant="outline" aria-label="cancel" tabindex="-1" (click)="close()">
        Cancel
    </button>

    <button class="hide-on-mobile" id="makeCurrent" type="button" vng-button variant="primary" aria-label="make current" (click)="makeCurrent()" tabindex="-1">
        Make Current
    </button>
</div>